import { render, staticRenderFns } from "./AdminSettingsForm.vue?vue&type=template&id=02127c02"
import script from "./AdminSettingsForm.vue?vue&type=script&lang=ts"
export * from "./AdminSettingsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports